/**
 * Parse API datetimes.
 * - With Z or offset (API standard): instant UTC → browser shows local time (Spain).
 * - Without offset (legacy): wall-clock in the browser timezone (local dev).
 */
export function parseApiDateTime(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
}

const DEFAULT_FORMAT_OPTIONS = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
};

/** Format API datetime in the user's locale (es-ES → hora de España en navegadores locales). */
export function formatApiDateTime(value, options = {}) {
  const { locale = 'es-ES', fallback = '—', includeSeconds = false, ...rest } = options;
  const date = parseApiDateTime(value);
  if (!date) return fallback;

  return date.toLocaleString(locale, {
    ...DEFAULT_FORMAT_OPTIONS,
    ...(includeSeconds ? { second: '2-digit' } : {}),
    ...rest,
  });
}
